import type { FtpUser } from '~/types/Account'
import type { TablePaginationRequest, TablePaginationResponse } from '~/types/GenericTable'
import { api } from '~/utils/backend'

export function paginateFtpUsers(request: TablePaginationRequest) {
  return api.post<TablePaginationResponse<FtpUser>>('/ftp-accounts/paginate', request)
}

export function deleteFtpUser(id: number) {
  return api.delete<never>('/ftp-accounts/' + id)
}

export function saveFtpUser(account: FtpUser) {
  return api.post<FtpUser>('/ftp-accounts/', account)
}

export function validateFtpUser(id: number | null, username: string) {
  const params = {
    username: username,
    id: id,
  }
  return api.get<boolean>('/ftp-accounts/username', { params })
}
